<div class="tt-guideline-sync-popover_header">
  <mat-icon class="tt-guideline-sync-popover_header-icon" [icon]="'cloud-download'" [iconSize]="28" />
  <div class="tt-guideline-sync-popover_header-text">
    <div class="tt-guideline-sync-popover_header-title">
      @if (status().syncing) {
        {{ 'Offline.SyncPopup.InProgressTitle' | transloco }}
      } @else {
        {{ 'Offline.SyncPopup.DoneTitle' | transloco }}
      }
    </div>
    <div class="tt-guideline-sync-popover_header-description">
      {{ 'Offline.SyncPopup.Description' | transloco }}
    </div>
  </div>
</div>
<div class="tt-guideline-sync-popover_process">
  <div class="tt-guideline-sync-popover_process-text">
    @if (status().syncing) {
      <mat-icon class="tt-guideline-sync-popover_process-text-icon" [icon]="'refresh-cw'" [iconSize]="16" />
    } @else {
      <mat-icon
        class="tt-guideline-sync-popover_process-text-icon tt-guideline-sync-popover_process-text-icon--done"
        [icon]="'check'"
        [iconSize]="16"
      />
    }
    <div>
      {{ 'Offline.SyncPopup.Process' | transloco }}:
      <span class="tt-guideline-sync-popover_process-text-status">
        {{ status().synced.length }}/{{ status().synced.length + status().remaining.length }}
      </span>
    </div>
  </div>
  <div
    class="tt-guideline-sync-popover_process-bar"
    [class.tt-guideline-sync-popover_process-bar--done]="progress() === 100"
  >
    <div class="tt-guideline-sync-popover_process-bar-progress" [style.width]="`${progress()}%`"></div>
  </div>
</div>

@if (status().syncing) {
  <div class="tt-guideline-sync-popover_hint">{{ 'Offline.SyncPopup.Hint' | transloco }}</div>
}
